_require [
  'jquery',
  'jquery/select2'
], ->
  $(document).ready ->

    _require ['jquery/perfect-scrollbar'], ->
      $('.js-document-modal-content-scroll').perfectScrollbar()

    $('.js-select2-fields').select2
      placeholder: () ->
        field = $(this).attr('data-field')
        if field == 'city_state'
          return "Escolha uma cidade"
        else if field == 'university'
          return 'Escolha uma universidade'
        else
          return 'Escolha um curso'
      multiple: false
      minimumInputLength: 3
      theme: 'normal-m'
      ajax:
        url: () ->
          field = $(this).attr('data-field')
          if field == 'city_state'
            return "/cities_search.json"
          else if field == 'university'
            return '/simple_universities_search.json'
          else
            return '/courses_autocomplete.json'
        dataType: 'json'
        delay: 700
        data: (params)->
          return {
            term: params.term,
            per_page: 10,
            page: params.page || 1,
            id_val: '1' if $(this).attr('data-field') == 'course'
          }
        processResults: (data, params) ->
          if typeof data.total == "undefined"
            more = ((params.page || 1 ) * 10) < data.meta.total
          else
            more = ((params.page || 1 ) * 10) < data.total

          if typeof data.items == "undefined" && typeof data.cities == "undefined"
            results = data.results
          else if typeof data.cities == "undefined"
            results = data.items
          else
            results = []
            length = data.meta.total
            i = 0
            while i < length
              results.push({
                text: data.cities[i].city,
                id: data.cities[i].id
              })
              i++

          return { results: results, pagination: {
            more: more
          } }

    fetcher = $('.js-select')
    universityField = $('.js-select2[data-field="university"]')
    fetcher.select2({
      placeholder: "Escolha uma universidade primeiro"
      theme: 'normal-m'
      data: []
      multiple: false
      tags: true
    })

    $formSubmit = $('.js-enrolled-courses__form__submit')
    $nameField = $('.enrolled-courses__form .js-enrolled-courses__form__name-field')

    checkNameField = () ->
      value = $nameField.val()
      return (value.length >= 5 && /[a-zA-Z]+[\s]+[a-zA-Z]+/.test(value))

    addErrorCheckingNameField = () ->
      if checkNameField()
        $nameField.removeClass('error')
      else
        $nameField.addClass('error')

    $('.js-enrolled-course-form-element').on 'submit', (e) ->
      unless checkNameField()
        e.preventDefault()
        e.stopPropagation()

    $nameField.on 'blur onfocusout', ->
      addErrorCheckingNameField()

    fetcher.select2('enable', $('#university').val() ? true : false)

    $('.js-select2-fields[data-field="university"]').on 'change', (e) ->
      fetcher = $('.js-select')
      fetcher.select2('enable')
      fetcher.empty()
      $.ajax
        url: '/simple_campus_search.json'
        quietMillis: 500
        data: {
          university_id: $('.js-select2-fields[data-field="university"]').val()
        }
        cache: true
        success: (data) ->
          fetcher = $('.js-select')
          fetcher.select2({
            placeholder: "Escolha uma universidade primeiro"
            theme: 'normal-m'
            data: data.results
            multiple: false
            tags: true
          })
